







































import { Component, Vue } from "vue-property-decorator";
import * as firebase from "firebase/app";
import "firebase/auth";
firebase.auth().languageCode = "ja";

@Component
export default class PasswordResetApp extends Vue {
  email = "";
  message = "";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private ruleEmail: any = [
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) => !!v || "入力が必須です。",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) => /.+@.+\..+/.test(v) || "有効なメールアドレスではありません。",
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get refs(): any {
    return this.$refs;
  }

  sendResetMail() {
    this.message = "";
    if (this.refs.sendResetForm.validate()) {
      this.doSendResetMail();
    }
  }

  doSendResetMail() {
    const auth = firebase.auth();
    auth.sendPasswordResetEmail(this.email).then(
      () => {
        // 正常系
        this.$router.push({ name: "Login" });
      },
      () => {
        //エラー系
        this.message = "このメールアドレスは使用できません。";
      }
    );
  }

  public mounted() {
    document.title =
      "パスワードをリセット | favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
    const descriptonMeta = document.querySelector("meta[name='description']");
    if (descriptonMeta) {
      descriptonMeta.setAttribute(
        "content",
        "パスワードをリセット | favsalonならサロンに特化したネットショップを簡単に作ることができます。シークレットサービスを作ってお客様の再来率を向上させることが可能です。"
      );
    }
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute("content", "noindex");
    }
  }
}
